import React from 'react';
import Sidebar from "../components/Sidebar";
import Mailbox from "../components/Mailbox";
import MailContent from "../components/MailContent";
import ComposeMessage from "../components/ComposeMessage";

import {useQuery} from "react-query";
import axiosInstance from "../libs/axiosInstant";

import {useDispatch} from "react-redux";
import {setConfig, setLabels} from "../stores/mailbox";
import {ToastContainer} from "react-toastify";

function MessageCenter() {

    //const mailBox = useSelector((state) => state.mailBox)
    const dispatch = useDispatch()

    const fetchConfig = async () => {
        const {data} = await axiosInstance.get('/inbox/settings');
        dispatch(setConfig({config: data}));
        return data;
    }
    const fetchLabels = async () => {
        const {data} = await axiosInstance.get('/inbox/labels');
        dispatch(setLabels({labels: data}));
        return data;
    }
    const configQuery = useQuery('config', fetchConfig)
    const {isLoading, isError, error, isSuccess} = useQuery('labels', fetchLabels)

    if (isLoading || configQuery.isLoading) {
        return <div className="d-flex justify-content-center">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <strong role="status">Loading...</strong>
        </div>
    }
    if (isError) {
        return <div className="alert alert-danger">{error}</div>
    }

    if (isSuccess) return <div>
        <ToastContainer />
        <Sidebar/>
        <Mailbox/>
        <MailContent/>
        <ComposeMessage/>
    </div>

}

export default MessageCenter;
